import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import EventSelection from './pages/EventSelection';
import EventPayment from './pages/EventPayment';
import EventInfo from './pages/EventInfo';
import ServiceSelection from './pages/ServiceSelection';
import AddonSelection from './pages/AddonSelection';
import TimeSlotSelection from './pages/TimeSlotSelection';
import DevoteeDetails from './pages/DevoteeDetails';
import FamilySelection from './pages/FamilySelection';
import BookingOverview from './pages/BookingOverview';
import Register from './pages/Register';
import GuestLogin from './pages/GuestLogin';
import QRCodeGenerator from './components/QRCodeGenerator';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <div className="flex flex-col min-h-screen bg-gray-50">
          <Header />
          
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Navigate to="/events" replace />} />
              <Route path="/home" element={<Home />} />
              <Route path="/country" element={<Navigate to="/events" replace />} />
              <Route path="/center" element={<Navigate to="/events" replace />} />
              <Route path="/events" element={<EventSelection />} />
              <Route path="/register" element={<Register />} />
              <Route path="/guest-login" element={<GuestLogin />} />
              <Route path="/event-info" element={<EventInfo />} />
              <Route path="/service" element={<ServiceSelection />} />
              <Route path="/addon" element={<AddonSelection />} />
              <Route path="/time-slot" element={<TimeSlotSelection />} />
              <Route path="/devotee" element={<DevoteeDetails />} />
              <Route path="/family" element={<FamilySelection />} />
              <Route path="/overview" element={<BookingOverview />} />
              <Route path="/event-payment" element={<EventPayment />} />
              <Route path="/qr-generator" element={<QRCodeGenerator />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </Router>
    </Provider>
  );
}

export default App;
